import React from 'react';

interface BannerProps {
  isVisible: boolean;
  message: string;
  /**
   * `fixed` (the default) pins the bar itself. `inline` leaves positioning to
   * the caller, which is what lets two banners stack: both are `fixed` by
   * default, and a fixed element with no `top` keeps its static position, so a
   * second one lands on top of the first rather than under it.
   */
  variant?: 'fixed' | 'inline';
}

const Banner: React.FC<BannerProps> = (props) => {
  const { isVisible, message, variant = 'fixed' } = props;

  if (isVisible) {
    return (
      <div
        className={`bg-alert w-full text-center${
          variant === 'fixed' ? ' fixed z-10' : ''
        }`}
      >
        <div className="text-center py-3 font-bold text-2xl">{message}</div>
      </div>
    );
  }

  return null;
};

export default Banner;
